import React from "react";

const ForkKnife = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="none"
			>
				<path
					d="M5.90625 2.25V5.0625"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5.90625 8.15625V15.75"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.875 2.25L8.4375 5.625C8.4375 6.29633 8.17082 6.94016 7.69611 7.41486C7.22141 7.88957 6.57758 8.15625 5.90625 8.15625C5.23492 8.15625 4.59109 7.88957 4.11639 7.41486C3.64168 6.94016 3.375 6.29633 3.375 5.625L3.9375 2.25"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.3438 11.25H10.4062C10.4062 11.25 11.25 3.375 14.3438 2.25V15.75"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};
export default ForkKnife;
